import { BackofficeRestMutations } from "@/api/backofficeRest/mutations"
import {
  InstallCodesBulkUploadRequest,
  InstallCodesUploadResponse,
} from "@/api/backofficeRest/generated/model"
import { MutationResult } from "@/api/utils/types"
import { useMutation } from "@/api/utils/useQuery"

export interface IBulkInstallCodesUploadMutator {
  upload(): MutationResult<
    InstallCodesBulkUploadRequest,
    InstallCodesUploadResponse
  >
}

class BulkInstallCodesUploadMutatorClass implements IBulkInstallCodesUploadMutator {
  upload(): MutationResult<
    InstallCodesBulkUploadRequest,
    InstallCodesUploadResponse
  > {
    return useMutation({
      ...BackofficeRestMutations.smartMeter.uploadInstallCodes(),
      serializerFn: (data: InstallCodesBulkUploadRequest) => data,
      invalidateCache: false,
    })
  }
}

export const BulkInstallCodesUploadMutator =
  new BulkInstallCodesUploadMutatorClass()
